// features/auth/authActions.js
import { createAsyncThunk } from '@reduxjs/toolkit'
import { loginApi, loginLog } from './authApi'
import { googleLoginApi } from './authApi';
import { verifyOtpApi } from './authApi';
import { resendOtpApi } from './authApi';

export const loginUser = createAsyncThunk(
  'auth/loginUser',
  async (payload, { rejectWithValue }) => {
    try {
      return await loginApi(payload);
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const googleLogin = createAsyncThunk(

  'auth/google-login',
  async (token, {rejectWithValue} ) => {
    try {
      return await googleLoginApi(token);
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const verifyOtp =createAsyncThunk(

"auth/verify-otp",

async(payload,{rejectWithValue})=>{

    try{

        return await verifyOtpApi(payload.email,payload.otp);

    }catch(err){

        return rejectWithValue(err);

    }

}

);

export const resendOtp = createAsyncThunk(
  "auth/resend-otp",
  async (email, { rejectWithValue }) => {
    try {
      return await resendOtpApi(email);
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);